import { inject, Injectable } from '@angular/core';
import { TIMEZONES } from './timezone-list';
import { Store } from '@ngrx/store';
import { TimezoneSelector } from '@dashboard/dashboard-store';
import { map, of, switchMap } from 'rxjs';
import { ApplyTimezoneToLocalDate } from '@core/constants/time.defaults';

@Injectable({
  providedIn: 'root',
})
export class TimezonesService {
  private _store = inject(Store);

  private timezones = TIMEZONES;
  public timezoneData$ = this._store.select(TimezoneSelector).pipe(
    map((tz) => ({
      tzOffset: tz,
      tzPreview: this.getTimezoneByHour(tz).valueStr,
    }))
  );

  public getTimezoneByHour(value: number) {
    return this.timezones.find((timezone) => timezone.value === value);
  }

  public DateNow() {
    return this.timezoneData$.pipe(
      switchMap((tz) => of(ApplyTimezoneToLocalDate(new Date(), tz.tzOffset)))
    );
  }
  public GetDate(date: string) {
    return this.timezoneData$.pipe(
      switchMap((tz) => of(ApplyTimezoneToLocalDate(date, tz.tzOffset)))
    );
  }
}
